<i class="fa fa-calendar-alt"></i><b class="uppercase">{{active ? active.name : 'Chọn thời gian'}}</b>

